/**
 * TypeScript-apufunktio, joka varmistaa että kaikki switch-caset on käsitelty.
 *
 * Käyttötarkoitus:
 * - Switch-lauseissa exhaustiveness checkinä (varmistaa että kaikki caset käsitelty)
 * - If-else-ketjuissa viimeisenä else-haarana
 * - Union-tyyppien käsittelyssä varmistamaan että kaikki mahdolliset arvot on käsitelty
 *
 * Jos TypeScript valittaa tästä funktiosta, se tarkoittaa että joku case/arvo on käsittelemättä.
 *
 * Esimerkki käytöstä:
 * ```typescript
 * type Status = 'pending' | 'approved' | 'rejected'
 *
 * function handleStatus(status: Status) {
 *   switch (status) {
 *     case 'pending':
 *       return 'Odottaa'
 *     case 'approved':
 *       return 'Hyväksytty'
 *     case 'rejected':
 *       return 'Hylätty'
 *     default:
 *       return assertNever(status) // TypeScript varoittaa jos joku case puuttuu
 *   }
 * }
 * ```
 *
 * Jos lisäät uuden arvon Status-tyyppiin (esim. 'cancelled'), TypeScript antaa
 * virheen assertNever-kohdasta kunnes lisäät uuden casen.
 */
const assertNever = (x: never): never => {
  throw new Error(`Odottamaton arvo: ${String(x)}`)
}

export default assertNever
